import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import { DatepickerOptions } from 'ng2-datepicker';
import * as enLocale from 'date-fns/locale/en';

import {ToasterService} from "../../_services/toaster.service";
import {AuthenicationService} from "../../_services/authenication.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DoctorService} from "../../_services/doctor.service";
import {PatientsService} from "../../_services/patients.service";

declare var $: any;
import * as moment from "moment";
import {PricesService} from "../../_services/prices.service";

@Component({
  selector: 'app-book-appointment',
  templateUrl: './book-appointment.component.html',
  styleUrls: ['./book-appointment.component.css']
})
export class BookAppointmentComponent implements OnInit {

  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    displayFormat: 'MMM D[,] YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 1, // 0 - Sunday, 1 - Monday
    locale: enLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {['z-index']:'1',['width']:'100%'}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };

  bookAppointmentForm: FormGroup;
  submitted = false;
  userdetaild: string;
  returnUrl: string;
  mode: string = 'f2f';
  showhide: Boolean = false;
  showHide: Boolean = false;
  discounted_price: any;
  modeList: any[] = ['Phone','Video'];
  schedules: any;
  pricemode: any;
  priceddata: any;
  doctors: [];
  doctorss: [];
  sessions: any[] = [];
  price: any;
  docid: string = '';
  discount_price: any = '';
  dob: string;
  relation: string;
  parent_name: string;
  parent_email: string;
  parent_phone: string;
  today: string;
  todayTime: string;
  todayDateTime: string;

  predate: string;
  preid: string;
  isdisplaypre: Boolean = false;
  isdisplaymsg: Boolean = false;
  avavility: any[] = [];
  isdisplay: Boolean = true;
  ischecked: Boolean = true;
  pretime: string;
  userid: any;
  patients: any;
  consultMode: string;


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService,private spinnerService: Ng4LoadingSpinnerService, private doctorservice: DoctorService,private patientsService: PatientsService, private pricesService: PricesService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    this.today = moment(new Date()).format("YYYY-MM-DD");
    this.todayTime = moment(new Date()).format("HH:mm");
    this.todayDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm");
    this.userid = this.route.snapshot.params.id;

    let newMode = localStorage.getItem('mode');
    let setmode = (newMode == null) ? 'Phone' : newMode;

    let podtData = {status: true};

    this.doctorsList(podtData);
    this.getPatientById();



    this.bookAppointmentForm = this.formBuilder.group({
      doctors: ['', [Validators.required]],
      slot: ['', [Validators.required]],
      date: ['', ''],
      name: [{value: '', disabled: true}, [Validators.required]],
      email: [{value: '', disabled: true}, [Validators.required]],
      mode: [setmode, [Validators.required]],
      dob: [''],
      relation: [''],
      parent_name: [''],
      parent_phone: [''],
      troubles: ['', [Validators.required]],
    });

    this.consultMode = (this.bookAppointmentForm.controls.mode.value == 'video') ? 'Video' : this.bookAppointmentForm.controls.mode.value;

    const self = this;
    var date = new Date();
    date.setDate(date.getDate());
    $('.datepicker').datepicker({
      format: 'yyyy-mm-dd',
      todayHighlight: true,
      orientation: "auto",
      startDate: date,
      clearBtn: true
      // tslint:disable-next-line:only-arrow-functions
    }).on('changeDate', function(e) {
      self.onchangedate(e.format());
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  getPatientById() {
    this.patientsService.getPatientById(this.userid)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.patients = data.patientList;
            const sessionpayload = {
              clientid: this.userid
            };
            this.getPatientSessions(sessionpayload);

            this.bookAppointmentForm.controls.name.setValue(this.patients.users_name);
            this.bookAppointmentForm.controls.email.setValue(this.patients.users_email);

          } else {
            console.log('Patients', data.ResponseMessage);
          }
        },
        error => {
          console.log('Patients', error.error.ResponseMessage);
        });
  }

  doctorsById(id) {
    this.doctorservice.getDoctorById(id)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.doctorss = data.doctorsList[0];
            //console.log(data.doctorsList[0]['own_space']);
            if (this.mode == 'video'){
              this.pricemode = 'Video';
            }
            if (this.mode == 'f2f'){
              this.pricemode = 'F2F Without Venue';

            }

            this.getPriceByExperienceAndProfession(this.doctorss['mental_health_prof'],this.doctorss['experience'], this.pricemode, this.docid);

          } else {
            console.log('no data found');
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  getPriceByExperienceAndProfession(type,experience,mode,docid) {
    const payload = {
      mental_health_type: type,
      experience: experience,
      price_for: mode,
      docid: docid,
    };
    this.pricesService.getPriceByExperienceId(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.priceddata = data.priceList[0];
            this.price = this.priceddata.original_price;
            this.discounted_price = (this.priceddata.original_price);
          } else {
            this.price = 0;
            this.discounted_price = 0;
            console.log('no data found!!!');
          }

        },
        error => {
          this.price = 0;
          this.discounted_price = 0;
          console.log('Doctor', error);
        });
  }

  async onChangeSlot(id) {
    this.ischecked = false;
    this.preid = id;
    const schedulepayload = {
      id: this.preid
    };
    await this.scheduleById(schedulepayload);

  }

  onchangedate(date) {
    if (this.docid == ''){
      this.toaster.showError('Appointment','Please Select Therapist first');
      return;
    }
    const payload = {
      docid: this.docid,
      date: date,
      user_id: this.userid,
      today: this.today,
      time: this.todayTime,
      scheduleFor: 'All',
    };
    this.getDoctorAvalibilityByDateNew(payload);

  }

  doctorsAvavilityByDate(payload) {
    this.doctorservice.getDoctorAvavilityByDate(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.avavility = data.avilibility;
            this.isdisplay = true;
            this.isdisplaymsg = false;
          } else {
            // alert(data.ResponseMessage);
            this.avavility = [];
            this.isdisplay = true;
            this.isdisplaymsg = true;
            console.log('no data found');
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  };

  getDoctorAvalibilityByDateNew(payload) {
    this.doctorservice.getDoctorAvalibilityByDateNew(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.avavility = data.avilibility;
            this.isdisplay = true;
            this.isdisplaymsg = false;
          } else {
            this.avavility = [];
            this.isdisplay = true;
            this.isdisplaymsg = true;
            console.log('no data found');
          }

        },
        error => {
          this.avavility = [];
          this.isdisplay = true;
          this.isdisplaymsg = true;
          console.log('Doctor', error.error.ResponseMessage);
        });
  };

  doctorsList(data) {
    this.doctorservice.getDoctorsByStatus(data)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.doctors = data.doctorsList;

          } else {
            console.log('Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  selectionChanged(e){
    this.docid = e.target.value;
    this.doctorsById(this.docid)
  }

  get f() { return this.bookAppointmentForm.controls; }


  getDob(e){
    if (e !== undefined && e !== ''){
      let selectedDate = moment(e).format("YYYY-MM-DD");

      const differenceInYears = moment(this.today).diff(selectedDate, 'years');
      //console.log(differenceInYears);
      if (differenceInYears < 18){
        this.showHide = true;
        this.bookAppointmentForm.controls['relation'].setValidators([Validators.required]);
        this.bookAppointmentForm.controls['parent_name'].setValidators([Validators.required]);
        this.bookAppointmentForm.controls['parent_phone'].setValidators([Validators.required]);
      }
      else {
        this.showHide = false;
        this.bookAppointmentForm.controls['relation'].setErrors(null);
        this.bookAppointmentForm.controls['parent_name'].setErrors(null);
        this.bookAppointmentForm.controls['parent_phone'].setErrors(null);

        this.bookAppointmentForm.controls['relation'].setValidators(null);
        this.bookAppointmentForm.controls['parent_name'].setValidators(null);
        this.bookAppointmentForm.controls['parent_phone'].setValidators(null);
      }
    }

  }

  async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.bookAppointmentForm.invalid) {
      return;
    }
    let selectedDate;
    if (this.bookAppointmentForm.controls.dob.value != '') {
        selectedDate = moment(this.bookAppointmentForm.controls.dob.value).format("YYYY-MM-DD");
    }else{
      selectedDate = '';
    }

    let payl = {ids: this.bookAppointmentForm.controls.slot.value.toString()};

    this.doctorservice.checkAppointmentBooked(payl)
      .subscribe(async (data: any) => {
          if (data && data.ResponseCode === '200') {
              await this.proceedToCheckOut(this.bookAppointmentForm.controls,selectedDate);
          } else {
            this.toaster.showError('Session Booking','Session has been already booked by someone else');
          }
        },
        error => {
          this.toaster.showError('Session Booking',error);
        });


  }

  getPatientSessions(payload) {
    this.patientsService.getUserAppointment(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.sessions = data.ClientAppointment;
            let troubles = '';
            if (this.sessions.length > 0){
              let total = (this.sessions.length - 1);
              this.dob = (this.sessions[total].dob)?this.sessions[total].dob:'';
              troubles = this.sessions[total].troubles;
              console.log('this.dob',this.dob);
            }
            let dobb = (this.dob)?moment(this.dob).format("MMM D[,] YYYY"):'';
            this.bookAppointmentForm.controls.dob.setValue(dobb);
            this.bookAppointmentForm.controls.troubles.setValue(troubles);

            // console.log(this.sessions);
          } else {

          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }


  bookAppointment(payload) {
    this.patientsService.bookAppointment(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //alert(data.ResponseMessage);
            this.router.navigate([`/appointments-list/active`]);
          } else {
            alert(data.ResponseMessage);
            //this.toaster.showError('Add Patient', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          alert(error.error.ResponseMessage);
          //this.toaster.showError('Add Patient', error.error.ResponseMessage);
        });
  }

  async scheduleById(id) {
     this.patientsService.getScheduleById(id)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.schedules = data.avilibility[0];
            // if (this.schedules['location'] == 'Video'){
            //   this.modeList = this.schedules['location'];
            // }
            // else if (this.schedules['location'] == 'Phone'){
            //   this.modeList = this.schedules['location'];
            // }else{
            //   this.modeList = ['f2f'];
            // }
            //console.log(data.avilibility[0]);
          } else {
            console.log('no data found');
            return false;
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
          return false;
        });
  }


  async proceedToCheckOut(data,selectedDate=''){

    const payload = {
      docid: this.docid,
      appointmentMode: data.mode.value,
      scheduleId: data.slot.value,
      troubles: data.troubles.value,
      clientid: this.userid,
      original_price: this.price,
      discount_price: this.discount_price,
      coupon_code: '',
      dob: (selectedDate)?selectedDate:'',
      relation: (data.relation.value)?data.relation.value:'',
      parent_name: (data.parent_name.value)?data.parent_name.value:'',
      parent_email: '',
      parent_phone: (data.parent_phone.value)?data.parent_phone.value:'',
      payment_status: 'Free Session',
      payment_details: []
    };
    // console.log(payload);return;

    this.bookAppointment(payload);

  };

  changeMode(mode){
    localStorage.setItem('mode', mode);
    let newMode = localStorage.getItem('mode');

    this.consultMode = mode;
  };

}
